// <zzy-sidebar items='[{"key":"...","label":"...","icon":"..."}]' active="key"></zzy-sidebar>
class ZzySidebar extends HTMLElement {
  static get observedAttributes() { return ['items','active']; }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  render() {
    const items = JSON.parse(this.getAttribute('items') || '[]');
    const active = this.getAttribute('active') || '';
    const html = items.map(i => `
      <button data-key="${i.key}" class="${i.key === active ? 'active' : ''}">
        <span class="lbl">${i.label}</span>
      </button>
    `).join('');
    this.innerHTML = `
      <style>
        :host, zzy-sidebar { display:block; }
        zzy-sidebar nav {
          background: var(--zzy-surface);
          border: 1px solid var(--zzy-border);
          border-radius: var(--zzy-radius);
          padding: 8px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          min-width: 220px;
        }
        zzy-sidebar button {
          display: flex; align-items: center;
          background: transparent;
          border: 0;
          color: var(--zzy-text-mute);
          padding: 10px 14px;
          border-radius: 6px;
          text-align: left;
          cursor: pointer;
          font: 500 13px/1 var(--zzy-font);
          width: 100%;
        }
        zzy-sidebar button:hover { background: rgba(255,255,255,.04); color: var(--zzy-text); }
        zzy-sidebar button.active { background: rgba(185,137,45,.15); color: var(--zzy-accent); }
      </style>
      <nav>${html || '<span style="color:var(--zzy-text-mute);font-size:12px;padding:12px">Nenhum item</span>'}</nav>
    `;
    this.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('zzy-select', { detail: { key: btn.dataset.key }, bubbles: true }));
      });
    });
  }
}
customElements.define('zzy-sidebar', ZzySidebar);
